import { _ as _slicedToArray } from '../../../../slicedToArray-26803f33.js';
import { _ as _defineProperty } from '../../../../defineProperty-18999f8e.js';
import { _ as _asyncToGenerator, r as regenerator } from '../../../../index-6bb2031f.js';
import { runSession, setUpEffect, setUpImage } from '@pa/pilibs';
import { EFFECTS, createEffect, createImage, runEffect } from '@pa/editor-lib';
import { getLayerManipulations } from '../../../../external/index.js';
import '../../../../unsupportedIterableToArray-577176bf.js';
import '../../../../typeof-92b42de1.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function applyEffect(_x, _x2, _x3) {
  return _applyEffect.apply(this, arguments);
}

function _applyEffect() {
  _applyEffect = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(id, imageData, effect) {
    var _ref, _ref$json, json, _ref$category, category, _ref$settings, settings, subFolder, params, effectNO_EI, imageNO_EI, buffer, _yield$Promise$all, _yield$Promise$all2, effectEI, imageEI, _runSession, imageDataBuffer, cleanup;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = effect || {}, _ref$json = _ref.json, json = _ref$json === void 0 ? '' : _ref$json, _ref$category = _ref.category, category = _ref$category === void 0 ? '' : _ref$category, _ref$settings = _ref.settings, settings = _ref$settings === void 0 ? [] : _ref$settings, subFolder = _ref.subFolder;

            if (category) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", imageData);

          case 3:
            params = settings.reduce(function (acc, item) {
              acc[item.name] = item.value;
              return acc;
            }, {});

            if (!Object.values(EFFECTS).includes(category)) {
              _context.next = 11;
              break;
            }

            effectNO_EI = createEffect(category);
            imageNO_EI = createImage(imageData, id);
            _context.next = 9;
            return runEffect(imageNO_EI, effectNO_EI, _objectSpread(_objectSpread({}, params), {}, {
              effectName: category
            }));

          case 9:
            buffer = _context.sent;
            return _context.abrupt("return", buffer);

          case 11:
            if (json) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", imageData);

          case 13:
            _context.next = 15;
            return Promise.all([setUpEffect(json, subFolder), setUpImage(imageData)]);

          case 15:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            effectEI = _yield$Promise$all2[0];
            imageEI = _yield$Promise$all2[1];
            _runSession = runSession(imageEI, effectEI, params), imageDataBuffer = _runSession.result, cleanup = _runSession.cleanup;

            try {
              cleanup();
              imageEI.cleanup();
              effectEI.cleanup();
            } catch (error) {
              getLayerManipulations().logger(error, 'error');
            }

            return _context.abrupt("return", new ImageData(new Uint8ClampedArray(imageDataBuffer), imageData.width));

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _applyEffect.apply(this, arguments);
}

export { applyEffect as default };
